/* eslint-disable no-underscore-dangle */
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

import { Codeowners } from '../../consts/codeowners';
import { captureException } from '../exception';

type GoogleMaps = typeof google.maps;

class GoogleMapsWrapper {
  _mapsRef?: GoogleMaps;

  _setMapsRef(googleMapsInstance: GoogleMaps) {
    this._mapsRef = googleMapsInstance;
  }

  /**
   * maps might not be loaded - depends how quickly google's cdn responds (or if it succeeds)
   *
   * in more critical places, please use optional chaining.
   *
   * For new application roots, make sure initGoogleMaps is called
   */
  get maps(): GoogleMaps {
    return this._mapsRef!;
  }
}

export const googleRef = new GoogleMapsWrapper();

export function initGoogleMaps() {
  try {
    setOptions({
      key: window.GOOGLE_MAPS_API_KEY,
      v: '3',
      libraries: ['geometry', 'places'],
    });

    Promise.all([importLibrary('maps'), importLibrary('places'), importLibrary('geometry')])
      .then(() => {
        googleRef._setMapsRef(google.maps);
      })
      .catch((error) => {
        console.error('Error while loading Google Maps', error);
        captureException(error, Codeowners.JOBS_2);
      });
  } catch (error) {
    console.error('Error while initializing Google Maps', error);
    captureException(error, Codeowners.JOBS_2);
  }
}

export function mockGoogleMaps(mock: GoogleMaps) {
  googleRef._setMapsRef(mock);
}
